<template>
  <div class="d-flex">
    <span class="p-float-label inline flex-grow-1">
      <AnimatedInput v-model="name.given" type="text" :label="i18n.$gettext('Firstname')" :disabled="readOnly" @blur="$emit('blur')" />
    </span>
    <span v-if="additional" class="p-float-label inline " :class="{ 'mx-2': !isOnMobile, 'my-2': isOnMobile }">
      <Chips
        v-model="name.additional"
        separator=","
        :disabled="readOnly"
        :allow-duplicate="false"
        :add-on-blur="true"
        @blur="$emit('blur')"
      />
      <label><translate>Middlenames</translate></label>
    </span>
    <span class="p-float-label inline flex-grow-1" :class="{ 'ml-2': !additional }">
      <AnimatedInput v-model="name.family" type="text" :label="i18n.$gettext('Lastname')" :disabled="readOnly" @blur="$emit('blur')" />
    </span>
  </div>
</template>

<script lang="ts">

import {Options, Vue} from "vue-class-component"
import StructuredName from "@/model/common/carddav/StructuredName"
import InputText from "primevue/inputtext"
import Chips from "primevue/chips"
import breakpointUtil from "@/util/BreakpointUtil"
import AnimatedInput from "@/components/common/AnimatedInput.vue"
import i18n from "@/util/i18n"
import {useGettext} from "@jshmrtn/vue3-gettext"

@Options({
  components: {AnimatedInput, Chips},
  //@ts-ignore
  props: {
    name: [StructuredName, Object],
    readOnly: {
      type: Boolean,
      default: false
    },
    additional: {
      type: Boolean,
      default: true
    }
  },
  emits: [ 'blur' ]
})
export default class StructuredNameField extends Vue {

  i18n = useGettext()

  get isOnMobile(){
    return breakpointUtil.isOnMobile()
  }
}
</script>

<style scoped lang="scss">

</style>
